// extracted by mini-css-extract-plugin
export default {"pattern-gradient":"PrivacyPolicy_pattern-gradient__KSf6W","table":"PrivacyPolicy_table__n8iUx","article":"PrivacyPolicy_article__fI+o3"};